import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { shortbread } from '../../../utils/shortbread/index';

export const CookiePrefrences = (): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    shortbread.checkForCookieConsent();
  }, []);

  return (
    <a className="footerLink" onClick={() => shortbread.customizeCookies()}>
      {t('footer.cookiePreferences')}
    </a>
  );
};
